export const FETCH_TEAMS_REQUEST = 'FETCH_TEAMS_REQUEST'
export const FETCH_TEAMS_SUCCESS = 'FETCH_TEAMS_SUCCESS'
export const FETCH_TEAMS_FAILURE = 'FETCH_TEAMS_FAILURE'
export const POST_TEAM='POST_TEAM'


export const FETCH_PLAYERS_REQUEST = 'FETCH_PLAYERS_REQUEST'
export const FETCH_PLAYERS_SUCCESS = 'FETCH_PLAYERS_SUCCESS'
export const FETCH_PLAYERS_FAILURE = 'FETCH_PLAYERS_FAILURE'
export const DELETE_PLAYER='DELETE_PLAYER'
export const UPDATE_PLAYER='UPDATE_PLAYER'
export const POST_PLAYER='POST_PLAYER'

export const FETCH_COACHES_REQUEST = 'FETCH_COACHES_REQUEST'
export const FETCH_COACHES_SUCCESS = 'FETCH_COACHES_SUCCESS'
export const FETCH_COACHES_FAILURE = 'FETCH_COACHES_FAILURE'
export const POST_COACH='POST_COACH'
export const DELETE_COACH='DELETE_COACH'
export const UPDATE_COACH='UPDATE_COACH'

export const FETCH_MATCHES_REQUEST = 'FETCH_MATCHES_REQUEST'
export const FETCH_MATCHES_SUCCESS = 'FETCH_MATCHES_SUCCESS'
export const FETCH_MATCHES_FAILURE = 'FETCH_MATCHES_FAILURE'
export const POST_MATCH='POST_MATCH'

